const EvaluationList = () => import('Views/evaluation/evaluation-list');
const EvaluationDetail = () => import('Views/evaluation/evaluation-detail');

export default[
  { path: '/evaluation-list', component: EvaluationList },
  { path: '/evaluation-detail/:id', component: EvaluationDetail },
];



// WEBPACK FOOTER //
// ./src/router/evaluation.js